import { boot } from 'quasar/wrappers'
import vue3GoogleLogin from 'vue3-google-login'

export default boot(({ app }) => {
  if (window.location.href.includes('/youtube-iframe')) return;

  app.use(vue3GoogleLogin, {
      clientId: process.env.CLIENT_ID_GOOGLE_OAUTH2
    }
  )
})